'use strict';

var $ = require('jquery');
var ajax = require('../../utils/ajax');
var util = require('../../utils/util');

/**
 * @description loads product's navigation
 */
module.exports = function () {
    var wl = window.location;
    var $pidInput = $('.pdpForm input[name="pid"]').last();
    var $productBreadcrumb = $('.breadcrumb:not(".search-breadcrumb")');
    var $searchBreadcrumb = $('.breadcrumb.search-breadcrumb');
    var $backLinkContainer = $('.breadcrumb-back-to-search');
    var $backLink = $backLinkContainer.find('a.back-to-search-link');
    var backUrl;
    var hashObject;
    var hash;

    // if no hash exists, or no pid exists, or nav container does not exist, return
    if (window.location.hash.length <= 1 || !$pidInput.length) {
        return;
    }

    hash = window.location.hash.substr(1);
    hashObject = wl.hash.length > 1 ? util.getQueryStringParams(wl.hash.substr(1)) : {};

    // show back to search link, search breadcrumb and navigation if origin is search
    if ($backLink.length !== 0 && !$.isEmptyObject(hashObject) && hashObject.q) {
        // simply replace plus sign to avoid wrong search strings
        if (hashObject.hasOwnProperty('q')) {
            // eslint-disable-line no-prototype-builtins
            hashObject.q = hashObject.q.replace('+', ' ');
        }

        if (hashObject.hasOwnProperty('format')) {
            // eslint-disable-line no-prototype-builtins
            delete hashObject.format;
        }

        // start is determined via session storage
        if (hashObject.hasOwnProperty('start')) {
            // eslint-disable-line no-prototype-builtins
            delete hashObject.start;
        }

        $productBreadcrumb.hide();
        $searchBreadcrumb.removeClass('initially-hidden');

        backUrl = util.appendParamsToUrl(Urls.search, hashObject);
        $backLink.attr('href', backUrl);
        $backLinkContainer.removeClass('initially-hidden');
    }
};
